module.exports = __webpack_public_path__ + "static/img/a047.1a17e7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a047.jpg
// module id = V5Rv
// module chunks = 0